/* NightWatch cart drawer + cart page.
 * Defines <cart-drawer> so the theme's own product forms (quick add, sticky
 * add to cart) render into and open this drawer as well. */
(function () {
  if (customElements.get('cart-drawer')) return;

  var DRAWER_SECTION = 'nw-cart-drawer';

  function drawerEl() { return document.querySelector('cart-drawer.nwc-drawer'); }
  function pageEl() { return document.querySelector('[data-nw-cart-page]'); }
  function routes() {
    var d = drawerEl(), r = window.routes || {};
    return {
      add: (d && d.dataset.addUrl) || r.cart_add_url || '/cart/add',
      change: (d && d.dataset.changeUrl) || r.cart_change_url || '/cart/change',
      cart: (d && d.dataset.cartUrl) || r.cart_url || '/cart'
    };
  }
  function sectionIds() {
    var ids = [DRAWER_SECTION];
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    var p = pageEl();
    if (p && p.dataset.sectionId) ids.push(p.dataset.sectionId);
    return ids;
  }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function setLoading(on) {
    document.querySelectorAll('[data-nwc-contents],[data-nwc-page-contents]').forEach(function (el) {
      el.classList.toggle('is-loading', on);
      el.setAttribute('aria-busy', on ? 'true' : 'false');
    });
  }
  function showError(message) {
    document.querySelectorAll('[data-nwc-error]').forEach(function (el) {
      el.textContent = message || 'Something went wrong. Please try again.';
      el.hidden = false;
    });
  }

  function applySections(sections) {
    if (!sections) return;
    var count = null;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = parse(html);
      if (id === DRAWER_SECTION) {
        var fresh = doc.querySelector('[data-nwc-contents]');
        var current = document.querySelector('cart-drawer.nwc-drawer [data-nwc-contents]');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          current.dataset.count = fresh.dataset.count;
          count = parseInt(fresh.dataset.count, 10);
          var d = drawerEl();
          if (d) d.classList.toggle('is-empty', count === 0);
        }
      } else if (id === 'cart-icon-bubble') {
        var bubble = document.getElementById('cart-icon-bubble');
        var src = doc.querySelector('.shopify-section');
        if (bubble && src) bubble.innerHTML = src.innerHTML;
      } else {
        var p = pageEl();
        var freshPage = doc.querySelector('[data-nwc-page-contents]');
        if (p && freshPage) {
          var target = p.querySelector('[data-nwc-page-contents]');
          if (target) target.innerHTML = freshPage.innerHTML;
        }
      }
    });
    if (count !== null) {
      document.querySelectorAll('[data-nw-cart-count]').forEach(function (b) {
        b.textContent = count > 99 ? '99+' : String(count);
        b.hidden = count === 0;
      });
    }
    if (window.publish && window.PUB_SUB_EVENTS) {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'nightwatch-cart' }); } catch (e) {}
    }
  }

  function request(url, body) {
    setLoading(true);
    return fetch(url, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    }).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    }).then(function (r) {
      if (!r.ok || r.data.status) {
        throw new Error(r.data.description || r.data.message || 'Something went wrong. Please try again.');
      }
      return r.data;
    }).finally(function () { setLoading(false); });
  }

  function change(key, quantity) {
    var fd = new FormData();
    fd.append('id', key);
    fd.append('quantity', quantity);
    fd.append('sections', sectionIds().join(','));
    fd.append('sections_url', window.location.pathname);
    return request(routes().change + '.js', fd).then(function (data) {
      applySections(data.sections);
    }).catch(function (err) {
      showError(err.message);
    });
  }

  function add(form, submitter) {
    var fd = new FormData(form);
    fd.append('sections', sectionIds().join(','));
    fd.append('sections_url', window.location.pathname);
    if (submitter) submitter.setAttribute('aria-busy', 'true');
    return request(routes().add + '.js', fd).then(function (data) {
      applySections(data.sections);
      var d = drawerEl();
      if (d && !pageEl()) d.open(submitter);
    }).catch(function (err) {
      var d = drawerEl();
      if (d && !pageEl()) d.open(submitter);
      showError(err.message);
    }).finally(function () {
      if (submitter) submitter.removeAttribute('aria-busy');
    });
  }

  class NwCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.panel = this.querySelector('.nwc-drawer__panel');
      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-nwc-close]')) { e.preventDefault(); this.close(); }
      }.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }
    isOpen() { return this.classList.contains('is-open'); }
    open(trigger) {
      if (trigger) this.activeElement = trigger;
      else if (!this.activeElement) this.activeElement = document.activeElement;
      this.classList.add('is-open');
      document.documentElement.classList.add('nwc-lock');
      var self = this;
      setTimeout(function () {
        var close = self.querySelector('.nwc-drawer__close');
        (close || self.panel).focus({ preventScroll: true });
      }, 60);
    }
    close() {
      this.classList.remove('is-open');
      document.documentElement.classList.remove('nwc-lock');
      if (this.activeElement && this.activeElement.focus) this.activeElement.focus({ preventScroll: true });
      this.activeElement = null;
    }
    onKeydown(e) {
      if (!this.isOpen()) return;
      if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(
        this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    /* API used by the theme's product-form.js and quick-add.js */
    getSectionsToRender() { return sectionIds().map(function (id) { return { id: id, selector: '.shopify-section' }; }); }
    setActiveElement(el) { this.activeElement = el; }
    renderContents(parsedState) {
      applySections(parsedState && parsedState.sections);
      if (!pageEl()) this.open();
    }
  }
  customElements.define('cart-drawer', NwCartDrawer);

  /* Quantity buttons, remove links and the bundle upgrade */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-nwc-change]');
    if (link) {
      e.preventDefault();
      change(link.dataset.key, parseInt(link.dataset.qty, 10) || 0);
      return;
    }
    var opener = e.target.closest('[data-nw-cart-open], #cart-icon-bubble');
    if (opener && !pageEl()) {
      var d = drawerEl();
      if (!d) return;
      e.preventDefault();
      d.open(opener);
    }
  });

  /* NightWatch add to cart forms */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-nw-ajax-cart]')) return;
    e.preventDefault();
    add(form, e.submitter || form.querySelector('[type="submit"]'));
  });
})();
